import { Column,CreateDateColumn,Entity,JoinColumn,ManyToOne,OneToMany,PrimaryGeneratedColumn,UpdateDateColumn,VersionColumn,} from 'typeorm';

@Entity('count_ranges')
export class RmCountRanges {
  @PrimaryGeneratedColumn('increment', { name: 'count_range_id' })
  rmcountPriceListId: number;

    @Column('int', {
        nullable: false,
        // length: 30,
        name: 'min_value',
    })
    minValue: number;

    @Column('int', {
        nullable: false,
        // length: 30,
        name: 'max_value',
    })
    maxValue: number;

    @Column('int', {
        nullable: false,
        // length: 30,
        name: 'count',
    })
    count: number

    
  
    }

   

    
